<template>
  <img :src="srcPath" :alt="imageValues.alt" :style="`object-position: ${stylePosition};`" />
</template>

<script>
  export default {
    name: 'ImageElement',
    props: {
      imageData: Object,
      position: {
        type: [Number, String],
        default: 'default'
      }
    },
    computed: {
      imageValues() {
        return this.imageData
      },
      srcPath() {
        return `${this.imageValues.src}`
      },
      stylePosition() {
        return `${this.position}`
      }
    }
  }
</script>
